import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { WidgetState } from './types';
import { RootState } from '../types';

export const state: WidgetState = {
  settings: {
    isActive: false,
    name: '',
    type: 'BOOKING_WIDGET',
    logo: '' as any,
    company: '',
    property: '',
    theme: '',
    childrenNotAllowed: false,
    phoneNumber: '',
    style: {},
    injections: [],
    market: {},
  },
  error: null,
  isLoaded: false,
};

const namespaced = true;

export const widget: Module<WidgetState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
